module.exports = __webpack_public_path__ + "assets/8ceacd6b81b357135b66bc143512dedd.png";